import app from "/src/app/app.module";

app.config(['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('nl-nl', {
        FOUND_AFTER_FILTER: 'gevonden, na filteren',
        SUM_AMOUNT:"Som bedrag",
        SELECT_ALL: 'Alles selecteren',
        SELECT_NONE: 'Niets selecteren',
        RESET: 'Opnieuw instellen',
        SEARCH: 'Zoeken'
    });

    const enTranslations = {
        FOUND_AFTER_FILTER: 'found, when filtered',
        SUM_AMOUNT: 'Sum amount',
        SELECT_ALL: 'Select All',
        SELECT_NONE: 'Select None',
        RESET: 'Reset',
        SEARCH: 'Search'
    };

    $translateProvider.translations('en-us', enTranslations);
    $translateProvider.translations('en-gb', enTranslations);


    $translateProvider.preferredLanguage('nl-nl');
}]);